<template>
    <transition
        v-if="showMessage"
        name="fade"
    >
        <div
            class="p-4 bg-green-100 rounded-md"
            :class="[positionClasses]"
            role="alert"
        >
            <div class="flex">
                <div class="flex-shrink-0">
                    <!-- Heroicon name: solid/check-circle -->
                    <svg class="w-5 h-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <strong
                        v-if="!success.message"
                        class="font-bold"
                    >
                        Success!
                    </strong>
                    <p
                        v-else
                        class="text-sm font-medium text-green-800"
                    >
                        {{ success.message }}
                    </p>
                </div>
                <div class="pl-3 ml-auto">
                    <div class="-mx-1.5 -my-1.5">
                        <button
                            type="button"
                            class="inline-flex bg-green-100 rounded-md p-1.5 text-green-500 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                            @click.prevent="closeMessage"
                        >
                            <span class="sr-only">Dismiss</span>
                            <!-- Heroicon name: solid/x -->
                            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Success',
    props: {
        success: {
            type: [Array, Object, Boolean],
            default: function () {
                return { success: false };
            },
        },
        positionClasses: {
            type: String,
            required: false,
            default: 'fixed inset-x-0 bottom-0 z-50',
        },
    },
    data () {
        return {
             showMessage: this.success,
        };
    },
    methods: {
        hideAlert () {
            setTimeout(() => {
                this.showMessage = false;
            }, 10000);
        },
        closeMessage() {
            this.showMessage = false;
        },
    },
    mounted () {
        this.hideAlert();
    },
};

</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
</style>
